import React from 'react';
import { useTranslation } from 'react-i18next';

/**
 * Reference / liability notice for algorithm-generated test results.
 * @param {{ variant?: 'ability' | 'interest', className?: string }} props
 */
export default function AlgorithmResultsDisclaimer({ variant = 'ability', className = '' }) {
  const { t } = useTranslation();
  const prefix = variant === 'interest' ? 'interestTest' : 'test';

  return (
    <aside
      className={`rounded-lg border border-edge bg-surface-muted px-4 py-3 text-xs leading-relaxed text-ink-muted text-justify ${className}`}
      role="note"
    >
      <p className="font-medium text-ink">{t(`${prefix}.resultsDisclaimerShort`)}</p>
      <p className="mt-1.5">{t(`${prefix}.resultsDisclaimerLong`)}</p>
    </aside>
  );
}
